import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    CloneButton,
    ExportButton,
    TextField,
    ReferenceField,
    ReferenceArrayField,
    WithListContext,
    TextInput,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
} from "react-admin"
import * as buttons from "components/ui/buttons"
import { ReferenceArrayFieldShowLink } from "components/ui/layouts"


const getObjectFilters = (permissions: string): React.ReactElement[] => {
    const filters = [
        <TextInput source="name" />,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)
const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)


const ObjectList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            filters={getObjectFilters(permissions)}
            //filterDefaultValues={{ role: "Equipment" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <ReferenceField label={translate("resources.objects.fields.name")} source="id" reference="objects">
                    <TextField source="name" label={translate("resources.objects.fields.name")} />
                </ReferenceField>
                <ReferenceField label={translate("resources.objects.fields.object_category_id")} source="object_category_id" reference="object-categories">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceArrayField label={translate("resources.objects.fields.object_industry_ids")} source="object_industry_ids" reference="object-industries" >
                <WithListContext render={({ data }) => (
                    <>
                        {data?.map((tag, i) => (
                            <span key={tag.id}>{tag.name}{(i < (data.length - 1) && <>&nbsp;&#10142;&nbsp;</>)}</span>
                        ))}
                    </>
                )} />
                </ReferenceArrayField>
                <ReferenceArrayFieldShowLink source="parent_ids" reference="objects" />
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")} />
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <CloneButton label="" title={translate("ra.action.clone")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}

export default ObjectList